import { getAttributes, Mark } from '@tiptap/core';
import { MarkType } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';

type ClickHandlerOptions = {
  type: MarkType;
};

// Workaround for https://github.com/ueberdosis/tiptap/issues/4143
// To take control of the click event on the link.
function clickHandler(options: ClickHandlerOptions): Plugin {
  return new Plugin({
    key: new PluginKey(`handleClickLinkInner`),
    props: {
      handleClick: (editorView, _, event) => {
        if (event.button !== 0) {
          return false;
        }

        const eventTarget = event.target as HTMLElement;

        const attrs = getAttributes(editorView.state, options.type.name);
        const linkElement = eventTarget.closest(`a`);

        const href = linkElement?.href ?? attrs.href;
        const target = linkElement?.target ?? attrs.target;

        if (linkElement && href) {
          if (editorView.editable) {
            window.open(href, target);
          }

          return true;
        }

        return false;
      },
    },
  });
}

export const CustomLinkExtension = Mark.create({
  priority: 1000,
  addProseMirrorPlugins() {
    return [
      clickHandler({
        type: this.type,
      }),
    ];
  },
});
